import { IconStatus } from '@/shared/utils'
import { DeviceStatus } from './types'

export const DeviceStatusTitles: Record<DeviceStatus, string> = {
  [DeviceStatus.Active]: 'Активно',
  [DeviceStatus.Blocked]: 'Заблокировано',
  [DeviceStatus.Disabled]: 'Приостановлено',
  [DeviceStatus.NotConnected]: 'Не подключено',
}

export const DeviceStatusIcons: Record<DeviceStatus, IconStatus> = {
  [DeviceStatus.Active]: 'green',
  [DeviceStatus.Blocked]: 'red',
  [DeviceStatus.Disabled]: 'grey',
  [DeviceStatus.NotConnected]: 'yellow',
}
